export default __webpack_public_path__ + "static/media/dianoiva_7.b9426992.jpg";